import { useTranslation } from 'react-i18next';

import { EDayOfWeek } from '../types';

export function useDayOfWeekOptions() {
  const { t } = useTranslation();

  const dayOfWeekOptions = [
    {
      label: t('Lunes '),
      value: EDayOfWeek.Monday,
    },
    {
      label: t('Martes'),
      value: EDayOfWeek.Tuesday,
    },
    {
      label: t('Miércoles'),
      value: EDayOfWeek.Wednesday,
    },
    {
      label: t('Jueves'),
      value: EDayOfWeek.Thursday,
    },
    {
      label: t('Viernes'),
      value: EDayOfWeek.Friday,
    },
    {
      label: t('Sábado'),
      value: EDayOfWeek.Saturday,
    },
    {
      label: t('Domingo'),
      value: EDayOfWeek.Sunday,
    },
  ];

  return dayOfWeekOptions;
}
